// extracted by mini-css-extract-plugin
export default {"similarDetection__matchedNorm":"SimilarDetectionBody_similarDetection__matchedNorm__NKSjb","matchedIcon":"SimilarDetectionBody_matchedIcon__pX2aR"};